<ng-container *ngFor="let slot of slots">
  <app-schedule-slot [lessons]="slot.lessons" [range]="range" [homeMode]="homeMode" 
  [onlineClassText]="onlineClassText" [cancelledClassText]="cancelledClassText" [hibridClassText]="hibridClassText" [notificationsHeaderText]="notificationsHeaderText" />
</ng-container>
